/**
 * @generated SignedSource<<dcb638d5efee3bdddae5dcc1034f108c>>
 * @relayHash 0507c25737fc28aed3ec38fd944fa860
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1ae1dbf38b936a9ae4f0dd143906b7cf22c21e52f08c056bfbda1bdf5a4e3cc9

import type { ConcreteRequest } from 'relay-runtime';
export type useSkipDraftSyncSkipDraftContentQuery$variables = {
  contentId: string;
};
export type useSkipDraftSyncSkipDraftContentQuery$data = {
  readonly singleContent: {
    readonly id: string | null | undefined;
    readonly title: string | null | undefined;
    readonly version: {
      readonly ncsStepVersion: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useSkipDraftSyncSkipDraftContentQuery = {
  response: useSkipDraftSyncSkipDraftContentQuery$data;
  variables: useSkipDraftSyncSkipDraftContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": [
          "draft"
        ]
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      },
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "ncsStepVersion"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSkipDraftSyncSkipDraftContentQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSkipDraftSyncSkipDraftContentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0507c25737fc28aed3ec38fd944fa860",
    "id": "1ae1dbf38b936a9ae4f0dd143906b7cf22c21e52f08c056bfbda1bdf5a4e3cc9",
    "metadata": {},
    "name": "useSkipDraftSyncSkipDraftContentQuery",
    "operationKind": "query",
    "text": "query useSkipDraftSyncSkipDraftContentQuery($contentId:ID!){singleContent(id:$contentId,status:[\"draft\"]){id,title,version{ncsStepVersion}}}"
  }
};
})();

(node as any).hash = "d443b97bc4e41097cd60a592da561b7b";

export default node;
